/// <summary>
/// This visual provides the notification list content including filter, list and details.<br/>
/// It is loaded dynamically by the Center widget into its content area.<br/>
/// </summary>
/// <remarks>
/// Author: MKU<br/>
/// Date: 22.06.2026<br/>
/// Copyright ©: EUDT GmbH 2026 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 22.06.2026                                            ***<br/>
/// **********************************************************************<br/>
/// * - extracted list content from Center into separate widget          *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.UserNotificationCenterContent", jQuery.common.vcBaseV4, {

    myData: {
        entries: null,
        types: null,
        details: null,
    },

    myStatus: {
        showDetails: false,
        uncid: -1,
        blid: -1,
        bInit: true,
        listHeight: -1,
    },

    _create: function () {
        this._createVisual(410);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-user-notification-center-content");

            me.myData.types = JSON.parse(me.specific.lstTypes);

            me.myStatus.uncid = typeof (me.options.parameter.UncId) === 'undefined' ? -1 : me.options.parameter.UncId;

            me._buildHtml();
            me._setHeightsAndWidths();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            me._initStructure();
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure for filter, list and details
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                filter: {}, list: {}
            };

            //filter
            var obj = me.myHtml.filter;
            obj.wrapper = me._setWrapper("", "");
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col float-box");

            // new checkbox for edit mode to mark read notifications as unread
            obj.editReadWrapper = me._setObj("", "float-box").css("margin-top", "16px").css("margin-left", "20px");
            obj.chbEditRead = me._setInput("chb-edit-read", "").attr("type", "checkbox").attr("id", "chb-edit-read");
            obj.lblEditRead = $("<label>").attr("for", "chb-edit-read").text(me.specific.resources.markAsUnread).css("margin-left", "5px");
            obj.editReadWrapper.append(obj.chbEditRead, obj.lblEditRead);

            obj.wrapper.append(obj.filter, obj.editReadWrapper);

            //notification list
            obj = me.myHtml.list;
            obj.wrapper = me._setWrapper("", "vc-list ").css("border", "1px solid #ddd");
            obj.closeDetails = me._setObj("", "close-details vc-grid-margin-bottom").html(me.specific.resources.back).hide();
            obj.header = me._setListHeader("");

            var showDeleteCol = me.specific.isAdmin; // && me.options.parameter.UncTypeId === 1;
            var subjectWidth = showDeleteCol ? "w45" : "w50";

            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w5 read-state-header").css("text-align", "center").html(me.specific.resources.read));
            line.column.append(me._setListElement("", "w10").css("text-align", "center").html(me.specific.resources.date));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.recipient));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.project));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.type));
            line.column.append(me._setListElement("", subjectWidth).html(me.specific.resources.subject));

            if (showDeleteCol) {
                line.column.append(me._setListElement("", "w5 delete-header").css("text-align", "right").html(""));
            }

            obj.header.append(line.item);
            obj.entries = me._setObj("entries", "vc-list-table");
            obj.details = {};
            obj.details.wrapper = me._setWrapper("", "details vc-grid-margin-top").hide();
            obj.details.email = me._setObj("details-email", "vc-grid-1col button-toggle button-toggle-active").data("type", "email").html(me.specific.resources.content);
            obj.details.edit = me._setObj("details-edit", "vc-grid-1col  button-toggle ").data("type", "edit").html(me.specific.resources.editation);
            obj.details.content = me._setObj("details-edit-content", "").css("padding", "12px").css("border", "1px solid #ddd");

            obj.details.wrapper.append(obj.details.email, obj.details.edit, obj.details.content);

            obj.wrapper.append(obj.closeDetails, obj.header, obj.entries, obj.details.wrapper);

            me.myRoot.append(me.myHtml.filter.wrapper, me.myHtml.list.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {

            //init vc-filter
            me.myHtml.filter.filter.vcFilter({ callback: function () { me._filter(); } });

            // change event for the checkbox to switch between normal mode and edit mode for marking read notifications as unread
            me.myHtml.filter.chbEditRead.off("change").on("change", function () {
                var bEditMode = $(this).prop("checked");

                // change header text based on the mode
                var headerText = bEditMode ? (me.specific.resources.unread) : (me.specific.resources.read);
                me.myHtml.list.header.find(".read-state-header").html(headerText);

                if (bEditMode) {
                    // if edit mode, we hide the normal read checkboxes and show the revert checkboxes for read notifications
                    me.myHtml.list.entries.find(".chb-unread").hide();
                    me.myHtml.list.entries.find(".chb-read-revert").show();
                } else {
                    // if not in edit mode, we hide the revert checkboxes and show the normal read checkboxes
                    me.myHtml.list.entries.find(".chb-read-revert").each(function () {
                        var chb = $(this);
                        if (chb.prop("checked")) {
                            chb.removeClass("chb-read-revert").addClass("chb-unread").prop("checked", false).prop("disabled", false);
                        }
                    });
                     
                    me.myHtml.list.entries.find(".chb-read-revert").hide();
                    me.myHtml.list.entries.find(".chb-unread").show();
                }
            });

            //init list detail event
            me.myHtml.list.entries.off("click", '.vc-list-item').on("click", '.vc-list-item', function (e) {
                var target = $(e.target);

                if (target.closest(".icon-delete").length > 0) {
                    var item = target.closest(".vc-list-item");
                    var id = item.data("id");
                    me._deleteNotification(id, item);
                    return;
                }

                if (target.closest(".chb-unread").length > 0) {
                    var chb = target.closest(".chb-unread");
                    me._upateChecked(chb);
                    return;
                }

                // we only want to trigger the revert action if the checkbox is checked, otherwise we do nothing
                if (target.closest(".chb-read-revert").length > 0) {
                    var chb = target.closest(".chb-read-revert");
                    me._revertToUnread(chb);
                    return;
                }

                if (target.closest(".col0").length > 0) {
                    return;
                }

                me.myHtml.list.entries.find('.vc-list-item').removeClass("selected");
                var item = target;
                if (!item.hasClass("vc-list-item")) item = target.parents(".vc-list-item");
                item.addClass("selected");
                me.myStatus.uncid = item.data("id");
                me.myStatus.blid = item.data("blid");

                me._fetchDetails();
            });

            //init details content buttons
            me.myHtml.list.details.wrapper.find(".button-toggle").off("click").on("click", function (e) {
                me._showDetailContent($(this));
            }).button();

            me.myHtml.list.wrapper.find(".close-details").off("click").on("click", function (e) {
                me._toggleDetails(false);
            }).button();

        } catch (e) { me._writeErr(e); }
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the parameters passed from the parent widget
        /// </summary>
        var me = this;
        try {

            me._toggleDetails(false);

            me._setLoadingIcon(me.myHtml.list.entries);
            var param = {
                TypeId: 1,
                LoggerId: me.options.parameter.LoggerId,
                StartDate: me.options.parameter.StartDate,
                EndDate: me.options.parameter.EndDate,
                UncTypeId: me.options.parameter.UncTypeId,
                ShowAllUser: me.options.parameter.ShowAllUser
            };

            me.getData(param, function (result) {

                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                me.myData.entries = result;

                me._generateList();

                //check the first time we load entries if we find the given unc id
                if (me.myStatus.uncid != -1 && me.myStatus.bInit) {

                    if (me.myHtml.list.entries.find(".selected").length == 0) {
                        me.openInfoDialog(me.specific.resources.noEntryFound, { at: 'center center-20%', of: window });
                        me.myStatus.uncid = -1;
                    }
                    me.myStatus.bInit = false;
                }
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates a list from the data
        /// </summary>
        var me = this;

        try {

            if (me.myData.entries.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                me.myStatus.uncid = -1;
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");

            // fill entry list
            $.each(me.myData.entries, function (key, row) {
                me.myHtml.list.entries.append(me._fillRow(row));
            });

            me._filter();

            return true;

        } catch (e) { me._writeErr(e); return false; }
    },

    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {

            var line = me._setListItem();
            line.item.data("id", row.Id);
            line.item.data("blid", row.Blid);

            if (me.myStatus.uncid == row.Id) { line.item.addClass("selected") }

            var chkUnread = "";
            var isEditMode = me.myHtml.filter.chbEditRead ? me.myHtml.filter.chbEditRead.prop("checked") : false;

            if (row.CommitDate == null && !row.Read) {
                // unread if CommitDate is null AND Read is false
                line.item.addClass("unread");
                chkUnread = me._setInput("", "chb-unread").attr("type", "checkbox").prop("name", "chb-unread");
                if (isEditMode) {
                    chkUnread.hide();
                }
            } else {
                // read if CommitDate is not null OR Read is true
                chkUnread = me._setInput("", "chb-read-revert").attr("type", "checkbox").prop("name", "chb-read-revert").prop("checked", false);
                if (!isEditMode) {
                    chkUnread.hide();
                }
            }

            var showDeleteCol = me.specific.isAdmin; // && me.options.parameter.UncTypeId === 1;
            var subjectWidth = showDeleteCol ? "w45" : "w50";

            line.column.append(me._setListElement("", "w5 col0").css("text-align", "center").html(chkUnread).append($("<br>")));
            line.column.append(me._setListElement("", "w10").css("text-align", "center").html(moment(row.Timestamp, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY HH:mm:ss")));
            line.column.append(me._setListElement("", "w10").html(row.User));
            line.column.append(me._setListElement("", "w15").html(row.Project.length > 0 ? row.Project : "-"));
            line.column.append(me._setListElement("", "w10").html(me.myData.types.find(function (x) { return x.Key === row.TypeId; }).Value));
            line.column.append(me._setListElement("", subjectWidth).html((row.Subject && row.Subject.trim().length > 0) ? row.Subject : "&nbsp;"));

            if (showDeleteCol) {
                var deleteIcon = $("<i class='fa-solid fa-xmark icon-color-error icon-delete vc-list-icon'></i>").attr("title", me.specific.resources.delete);
                line.column.append(me._setListElement("", "w5").css("text-align", "right").html(deleteIcon));
            }

            return line.item;
        } catch (e) { me._writeErr(e); return false; }
    },

    _toggleDetails: function (bShow) {
        /// <summary>
        /// This function toggles between details and list view
        /// </summary>
        var me = this;
        try {

            if (bShow) {
                me.myHtml.filter.wrapper.hide();
                me.myHtml.list.header.hide();
                me.myHtml.list.closeDetails.show();

                me.myHtml.list.entries.find(".vc-list-item").hide();
                var item = me.myHtml.list.entries.find(".vc-list-item.selected");
                item.show();
                me.myHtml.list.wrapper.height(me._getVisualHeight() - 2);
                me.myHtml.list.entries.height(item.outerHeight() - 2);
                me.myHtml.list.details.email.hide();
                me.myHtml.list.details.edit.hide();
                me.myHtml.list.details.wrapper.show().height(me._getVisualHeight() - 124);
                me.myHtml.list.details.content.height(me._getVisualHeight() - me.myHtml.list.entries.height() - 146);
                me.myStatus.showDetails = true;
            } else {
                me.myHtml.filter.wrapper.show();
                me.myHtml.list.header.show();
                me.myHtml.list.closeDetails.hide();
                me.myHtml.list.details.wrapper.hide();
                me.myHtml.list.entries.height(me.myStatus.listHeight);
                me._filter();
                me.myStatus.showDetails = false;
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fetchDetails: function () {
        /// <summary>
        /// This function fetches the details for one single note
        /// </summary>
        var me = this;
        try {
            var bShow = !me.myStatus.showDetails;

            me._toggleDetails(bShow);

            if (bShow) {
                me._setLoadingIcon(me.myHtml.list.details.content);
                var param = { TypeId: 2, UncId: me.myStatus.uncid }
                me.getData(param, function (result) {

                    //check response content
                    if (result == null) {
                        me.showMessage(me.resources.err_loadData, true);
                        return true;
                    }
                    me.myData.details = result;

                    me.myHtml.list.details.content.css("overflow-y", "auto");
                    me.myHtml.list.details.content.html(me.myData.details.Body);

                    me.myHtml.list.details.content.html(me.myData.details.Body);

                    //stop if we do not need a sub widget
                    if (me.myData.details.NoteData.length > 0) {
                        me.myHtml.list.details.email.show();
                        me.myHtml.list.details.edit.show();

                        me.myHtml.list.details.email.removeClass("button-toggle-active").addClass("button-toggle-active");
                        me.myHtml.list.details.edit.removeClass("button-toggle-active");
                        return true;
                    }
                    

                });
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _showDetailContent: function (obj) {
        /// <summary>
        /// This function shows the content of one single note
        /// </summary>
        var me = this;
        try {

            

            //show the content for the different note types
            switch (me.myData.details.TypeId) {
                case 1: //data center email validation
                    if (obj.hasClass("button-toggle-active")) return;
                    //switch toggle state
                    me.myHtml.list.details.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                    obj.addClass("button-toggle-active");
                    if (obj.data("type") == "email") {
                        me.myHtml.list.details.content.css("overflow-y", "auto");
                        me.myHtml.list.details.content.html(me.myData.details.Body);
                        return;
                    }

                    var subId = JSON.parse(me.myData.details.NoteData);
                    me.myHtml.list.details.content.css("overflow-y", "hidden");
                    me.myHtml.list.details.content.DcValidationEmailList({ invokeType: "addVisualContent", parameter: { LoggerId: me.myStatus.blid, EmailHash: subId } });
                    break;

                case 3: //tickets
                    //var ticketId = JSON.parse(me.myData.details.NoteData);
                    me.vcV.showSingleTicketDialog(me.myStatus.blid, {
                        TicketID: me.myData.details.NoteData,
                        LoggerID: me.myStatus.blid,
                        readOnlyMode: false,
                        startEntry: null
                    });
                    //me.myHtml.list.details.content.css("overflow-y", "hidden");
                    //me.myHtml.list.details.content.DcValidationEmailList({ invokeType: "addVisualContent", parameter: { LoggerId: me.myStatus.blid, EmailHash: subId } });
                    break;

                case 5: //alarms
                    if (obj.hasClass("button-toggle-active")) return;
                    //switch toggle state
                    me.myHtml.list.details.wrapper.find(".button-toggle").removeClass("button-toggle-active");
                    obj.addClass("button-toggle-active");
                    if (obj.data("type") == "email") {
                        me.myHtml.list.details.content.html(me.myData.details.Body);
                        return;
                    }
                    if (me.myData.details.NoteData.length > 0) {
                      
                        var raw = me.myData.details.NoteData;
                        if (raw.startsWith('"') && raw.endsWith('"')) raw = JSON.parse(raw); // entpackt den äußeren String
                        let jsonStr = raw.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
                        let alarm = JSON.parse(jsonStr);
                        me.myHtml.list.details.content.html("<div id='div-alarm-chart1' style='height:100px'></div>");
                        me.vcV.addVisualBaseByName("div-alarm-ch", "VISUAL_ALARMHISTORY", 'art1', alarm.day, 700, parseInt(me.myHtml.list.details.content.width()), JSON.stringify({ 'StartDate': alarm.day, 'EndDate': alarm.day, 'FixedContentHeight': true, aid: [alarm.id] }), "", 2);

                    }
                   
                    break;


                default:
            }

        } catch (e) { me._writeErr(e); }
    },

    _upateChecked: function (obj) {
        /// <summary>
        /// This function updates the read state of a notification
        /// </summary>
        var me = this;
        try {

            let item = obj.parents(".vc-list-item");
            obj.hide();
            var param = { TypeId: 1, UncId: item.data("id") };
            me.updateData(param, function (result) {
                if (result) {
                    item.removeClass("unread");

                    // we remove the checkbox from the DOM and create a new one, so that we can have a clean state for the revert action
                    obj.remove();

                    // we check if we are in edit mode, if so we show the revert checkbox, otherwise we hide it
                    var isEditMode = me.myHtml.filter.chbEditRead ? me.myHtml.filter.chbEditRead.prop("checked") : false;
                    var newChb = me._setInput("", "chb-read-revert").attr("type", "checkbox").prop("name", "chb-read-revert").prop("checked", false);
                    if (!isEditMode) {
                        newChb.hide();
                    }

                    // we add the new checkbox to the DOM in the same place as the old one
                    var col0 = item.find(".col0");
                    col0.prepend(newChb);

                    // notify parent widget to refresh counts
                    me.element.trigger("notificationRead");
                } else {
                    obj.show();
                }
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _revertToUnread: function (obj) {
        /// <summary>
        /// This function reverts a read notification back to unread
        /// </summary>
        var me = this;
        try {
            let item = obj.parents(".vc-list-item");

            var isChecked = obj.prop("checked");
            // we only want to revert to unread if the checkbox is checked, otherwise we do nothing
            if (isChecked) {
                var param = { TypeId: 1, UncId: item.data("id"), IsRead: false };

                me.updateData(param, function (result) {
                    if (result) {
                        // we mark the item as unread in the UI
                        item.addClass("unread");

                        obj.prop("disabled", true);

                        // we update the counts in the parent widget to reflect the change
                        me.element.trigger("notificationRead");
                    } else {
                        obj.prop("checked", false);
                    }
                });
            }

        } catch (e) { me._writeErr(e); }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the available content height
        /// </summary>
        var me = this;
        try {

            let h = me._getVisualHeight();
            let filterH = me.myHtml.filter.wrapper.outerHeight(true);

            me.myHtml.list.wrapper.css("height", h - filterH);

            //set height of main list
            me.myStatus.listHeight = parseInt(h - filterH - me.myHtml.list.header.outerHeight(true) - 25);
            me.myHtml.list.entries.css("height", me.myStatus.listHeight).css("maxHeight", me.myStatus.listHeight);

        } catch (e) { me._writeErr(e); }
    },

    _filter: function () {
        this._doListTableFilter(this.myHtml.list.entries);
    },


    _deleteNotification: function (id, item) {
        /// <summary>
        /// This function deletes a notification from the list and the database
        /// </summary>
        var me = this;
        try {
            me.openAskDialog(me.specific.resources.deleteConfirm, { my: 'center', at: 'center', of: window }, function () {

                console.log("me.options.parameter.UncTypeId", me.options.parameter.UncTypeId);

                var param = { TypeId: 2, UncId: id, UncTypeId: me.options.parameter.UncTypeId };

                me.updateData(param, function (result) {
                    if (result) {
                        item.remove();
                        if (me.myData.entries && $.isArray(me.myData.entries)) {
                            var filtered = [];
                            for (var i = 0; i < me.myData.entries.length; i++) {
                                if (me.myData.entries[i].Id !== id) {
                                    filtered.push(me.myData.entries[i]);
                                }
                            }
                            me.myData.entries = filtered;
                        }
                        me._filter();

                        // update the parent widget to refresh counts
                        me.element.trigger("notificationRead");
                    } 
                });
            }, function () {
                return true;
            });
        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.myHtml.filter.wrapper.hide();
                me.myHtml.list.wrapper.hide();
            }
            return true;
        } catch (e) {
            me.writeError(e); return false;
        }
    },

});